import { supabase } from "../supabaseClient";

export const contactService = {
  // Get all contacts for a user
  async getContacts(userId) {
    const { data, error } = await supabase
      .from("contacts")
      .select("*")
      .eq("user_id", userId)
      .order("name", { ascending: true });

    if (error) throw error;
    return data;
  },

  // Get a single contact by ID
  async getContact(userId, contactId) {
    const { data, error } = await supabase
      .from("contacts")
      .select("*")
      .eq("id", contactId)
      .eq("user_id", userId)
      .single();

    if (error) throw error;
    return data;
  },

  // Create a new contact
  async createContact(userId, contactData) {
    const { data, error } = await supabase
      .from("contacts")
      .insert({
        user_id: userId,
        name: contactData.name,
        relationship: contactData.relationship || null,
        work_email: contactData.work_email || null,
        personal_email: contactData.personal_email || null,
        work_phone: contactData.work_phone || null,
        personal_phone: contactData.personal_phone || null,
        address_1: contactData.address_1 || null,
        address_2: contactData.address_2 || null,
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Update an existing contact
  async updateContact(userId, contactId, contactData) {
    const updateData = {};
    if (contactData.name !== undefined) updateData.name = contactData.name;
    if (contactData.relationship !== undefined) updateData.relationship = contactData.relationship;
    if (contactData.work_email !== undefined) updateData.work_email = contactData.work_email;
    if (contactData.personal_email !== undefined) updateData.personal_email = contactData.personal_email;
    if (contactData.work_phone !== undefined) updateData.work_phone = contactData.work_phone;
    if (contactData.personal_phone !== undefined) updateData.personal_phone = contactData.personal_phone;
    if (contactData.address_1 !== undefined) updateData.address_1 = contactData.address_1;
    if (contactData.address_2 !== undefined) updateData.address_2 = contactData.address_2;

    const { data, error } = await supabase
      .from("contacts")
      .update(updateData)
      .eq("id", contactId)
      .eq("user_id", userId)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  // Delete a contact
  async deleteContact(userId, contactId) {
    const { error } = await supabase
      .from("contacts")
      .delete()
      .eq("id", contactId)
      .eq("user_id", userId);

    if (error) throw error;
    return true;
  },

  // Search contacts by name, email, or relationship
  async searchContacts(userId, query) {
    const searchTerm = `%${query}%`;
    const { data, error } = await supabase
      .from("contacts")
      .select("*")
      .eq("user_id", userId)
      .or(`name.ilike.${searchTerm},work_email.ilike.${searchTerm},personal_email.ilike.${searchTerm},relationship.ilike.${searchTerm}`)
      .order("name", { ascending: true });

    if (error) throw error;
    return data;
  },
};
